import { fallbackAutoGenerated } from './generated.fallbackAutoGenerated'

export const autoGeneratedEn: Record<
  keyof typeof fallbackAutoGenerated,
  string
> = {
  ...fallbackAutoGenerated,
}
